/**
 * Cliente HTTP base.
 * Pega contra el backend que Alejandro construirá.
 *
 * Maneja:
 * - JWT en Authorization header (lee de localStorage)
 * - Errores HTTP normalizados
 * - Base URL desde .env (VITE_API_BASE_URL)
 */

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

const getToken = () => localStorage.getItem('xp_auth_token');

const request = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  // 204 No Content
  if (res.status === 204) return null;

  let body = null;
  try {
    body = await res.json();
  } catch {
    // ignorar parse errors si no hay body
  }

  if (!res.ok) {
    throw new ApiError(body?.message || `HTTP ${res.status}`, res.status, body);
  }

  return body;
};

export const http = {
  get: (path, opts) => request(path, { ...opts, method: 'GET' }),
  post: (path, body, opts) => request(path, { ...opts, method: 'POST', body }),
  put: (path, body, opts) => request(path, { ...opts, method: 'PUT', body }),
  patch: (path, body, opts) => request(path, { ...opts, method: 'PATCH', body }),
  delete: (path, opts) => request(path, { ...opts, method: 'DELETE' }),
};

export { ApiError };
